<script>
import { Bar, mixins } from "vue-chartjs";

export default {
  mixins: [mixins.reactiveData, mixins.reactiveProp],
  extends: Bar,
  props: {
    chartData: {
      type: Array | Object,
      required: false
    },
    chartDataOfertada: {
      type: Array | Object,
      required: false
    },
    chartLabels: {
      required: true
    }
  },
  data() {
    return {
      options: {

        showScale: true,
          scales: {
            yAxes: [{
               
               ticks: {
                 beginAtZero: true,
                 backgroundColor: '#4F5565',
                 userCallback: function(label, index, labels) {
                     // when the floored value is the same as the value we have a whole number
                     if (Math.floor(label) === label) {
                         return label;
                     }

                 },
             }             
            }],
            xAxes: [ {
              ticks: {
                 beginAtZero: true,
                 backgroundColor: '#FFFFFF',
              }
            }]
          },
          tooltips: {
            backgroundColor: '#4F5565',
            titleFontStyle: 'normal',
            titleFontSize: 18,
            bodyFontFamily: "'Proxima Nova', sans-serif",
            cornerRadius: 3,
            bodyFontColor: '#20C4C8',
            bodyFontSize: 14,
            xPadding: 14,
            yPadding: 14,
            displayColors: false,
            mode: 'index',
            intersect: false,
            callbacks: {
              title: tooltipItem => {
                return `🗓 ${tooltipItem[0].xLabel}`
              },
              label: (tooltipItem, data) => {
                let dataset = data.datasets[tooltipItem.datasetIndex]
                let currentValue = dataset.data[tooltipItem.index]
                return `📦 ${currentValue.toLocaleString()}`
              }
            }
          },
          legend: {
            display: true
          },
        responsive: true,
        maintainAspectRatio: false
      }
    };
  },
  mounted() {
    this.renderChart(
      {
        labels: this.chartLabels,
        datasets: [
          {
            label: "adjudicada",
            data: this.chartData,
            backgroundColor: 'indigo',
          },{
            label: "postulada",
            data: this.chartDataOfertada,
            backgroundColor: 'blue',
          }
        ]
      },
      this.options
    );
  },
  methods: {
    formatNumber(num) {
      let numString = Math.round(num).toString();
      let numberFormatMapping = [[6, "m"], [3, "k"]];
      for (let [numberOfDigits, replacement] of numberFormatMapping) {
        if (numString.length > numberOfDigits) {
          let decimal = "";
          if (numString[numString.length - numberOfDigits] !== "0") {
            decimal = "." + numString[numString.length - numberOfDigits];
          }
          numString =
            numString.substr(0, numString.length - numberOfDigits) +
            decimal +
            replacement;
          break;
        }
      }
      return numString;
    }
  }
};
</script>